export function notifyAuthChanged() {
  window.dispatchEvent(new CustomEvent('slbk-auth-changed'))
}

export function openFollowBonus() {
  window.dispatchEvent(new CustomEvent('slbk-open-follow'))
}

export function onOpenFollow(handler) {
  window.addEventListener('slbk-open-follow', handler)
  return () => window.removeEventListener('slbk-open-follow', handler)
}

export function onAuthChanged(handler) {
  window.addEventListener('slbk-auth-changed', handler)
  return () => window.removeEventListener('slbk-auth-changed', handler)
}
